import { createApp } from 'vue';
import App from './App.vue';
//import Setting from './settings.vue';
//import EventLog from './Components/EventLog/event-log.vue';
//import Dashboard from './Components/DashboardWidget/dashboard.vue';
import { createPinia } from "pinia";
import './Assets/submissions.scss';
import 'element-plus/dist/index.css';
// import './assets/global.css'




const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

// const settingApp = createApp(Setting);
// settingApp.use(pinia);

// const analyticsApp = createApp(Analytics);
// analyticsApp.use(pinia);

// const eventLogApp = createApp(EventLog);
// eventLogApp.use(pinia);

//const dashboardWidgetApp = createApp(Dashboard);
//dashboardWidgetApp.use(pinia);


app.mount('#fv-submissions');
//settingApp.mount('#fv-settings-general');
//eventLogApp.mount('#fv-event-log-wrapper');
//analyticsApp.mount('#fv-analytics');
//dashboardWidgetApp.mount('#fv-dashboard-widgets-0');